import React, { useState, useEffect } from 'react';
import DynamicSection from './DynamicSection';

const DynamicSectionsBlock = () => {
  const [sections, setSections] = useState(null);

  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    fetch(`${backendUrl}/api/cms/sections`)
      .then(r => r.ok ? r.json() : [])
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        const sorted = [...list].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
        setSections(sorted);
      })
      .catch(() => setSections([]));
  }, [backendUrl]);

  if (!sections || sections.length === 0) return null;

  return (
    <>
      {sections.map((section, i) => (
        <React.Fragment key={section.id || section.slug || i}>
          <DynamicSection section={section} index={i} />
          {i < sections.length - 1 && (
            <div className="gold-divider my-0" />
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default DynamicSectionsBlock;
